export const seasonsBest = {
  recipes: [
    {
      id: 'Butter Chicken',
      link: 'https://pamperedchef.widen.net/view/thumbnail/nyrgg0egza/post-recipe-butter-chicken-steps.jpg?position=c&color=ffffffff&quality=80&t.format=jpeg&x.share=t',
      img: {
        src: 'https://pamperedchef.widen.net/content/nyrgg0egza/jpeg/post-recipe-butter-chicken-steps.jpg?w=200&h=200&position=c&color=ffffffff&quality=80',
        alt: 'post-recipe-butter-chicken-steps.jpg',
      },
    },
    {
      id: 'Fried Chicken Sandwich ',
      link: 'https://pamperedchef.widen.net/view/thumbnail/aei2jrwzsp/post-recipe-fried-chicken-sandwich-steps.jpg?position=c&color=ffffffff&quality=80&t.format=jpeg&x.share=t',
      img: {
        src: 'https://pamperedchef.widen.net/content/aei2jrwzsp/jpeg/post-recipe-fried-chicken-sandwich-steps.jpg?w=200&h=200&position=c&color=ffffffff&quality=80',
        alt: 'post-recipe-fried-chicken-sandwich-steps.jpg',
      },
    },
  ],
};
